import { isSamePosition } from '@wareena/game-algorithms';
import getNeighboursByTerrainPreferences from './getNeighboursByTerrainPreferences.js';
import getPositionsWithBetterTerrain from './getPositionsWithBetterTerrain.js';
import getPath from './getPath.js';
import sortPositionsByTerrainPreferences from './sortPositionsByTerrainPreferences.js';
function getPathToBecomeAdjacent(agentUnit, enemyUnit, hexProperties, rules, allUnits, mapHexes, terrainPreferences, shouldBeAbleToTravelTheWholePath = true) {
    let neighbours = getNeighboursByTerrainPreferences(enemyUnit.position, rules, mapHexes, terrainPreferences);
    const isAlreadyAdjacent = hexProperties.getDistance(agentUnit.position, enemyUnit.position) === 1;
    if (isAlreadyAdjacent) {
        const agentHex = mapHexes.find((h) => isSamePosition(h, agentUnit.position));
        if (!agentHex) {
            throw `Missing hex ${agentUnit.position.column}:${agentUnit.position.row} on map`;
        }
        neighbours = getPositionsWithBetterTerrain(neighbours, agentHex.terrainId, terrainPreferences, mapHexes);
        neighbours = sortPositionsByTerrainPreferences(neighbours, mapHexes, terrainPreferences);
    }
    for (const neighbour of neighbours) {
        const path = getPath(agentUnit, neighbour, hexProperties, rules, allUnits, mapHexes, shouldBeAbleToTravelTheWholePath);
        if (path) {
            return path;
        }
    }
    return null;
}
export default getPathToBecomeAdjacent;
